import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genFocusOutline } from '../../style';

var accessibilityFocus = function accessibilityFocus(token) {
  return Object.assign({}, genFocusOutline(token));
};

var getThemeStyle = function getThemeStyle(token, themeSuffix) {
  var _not$concat, _$concat3, _$concat4, _$concat$concat2, _$concat8, _$concat$concat$conca2;

  var componentCls = token.componentCls,
      itemColor = token.itemColor,
      itemSelectedColor = token.itemSelectedColor,
      groupTitleColor = token.groupTitleColor,
      itemBg = token.itemBg,
      subMenuItemBg = token.subMenuItemBg,
      itemSelectedBg = token.itemSelectedBg,
      activeBarHeight = token.activeBarHeight,
      activeBarWidth = token.activeBarWidth,
      activeBarBorderWidth = token.activeBarBorderWidth,
      motionDurationSlow = token.motionDurationSlow,
      motionEaseInOut = token.motionEaseInOut,
      motionEaseOut = token.motionEaseOut,
      itemPaddingInline = token.itemPaddingInline,
      motionDurationMid = token.motionDurationMid,
      itemHoverColor = token.itemHoverColor,
      lineType = token.lineType,
      colorSplit = token.colorSplit,
      itemDisabledColor = token.itemDisabledColor,
      dangerItemColor = token.dangerItemColor,
      dangerItemHoverColor = token.dangerItemHoverColor,
      dangerItemSelectedColor = token.dangerItemSelectedColor,
      dangerItemActiveBg = token.dangerItemActiveBg,
      dangerItemSelectedBg = token.dangerItemSelectedBg,
      itemHoverBg = token.itemHoverBg,
      itemActiveBg = token.itemActiveBg,
      menuSubMenuBg = token.menuSubMenuBg,
      horizontalItemSelectedColor = token.horizontalItemSelectedColor,
      horizontalItemSelectedBg = token.horizontalItemSelectedBg,
      horizontalItemBorderRadius = token.horizontalItemBorderRadius,
      horizontalItemHoverBg = token.horizontalItemHoverBg,
      popupBg = token.popupBg;
  return _defineProperty({}, "".concat(componentCls, "-").concat(themeSuffix, ", ").concat(componentCls, "-").concat(themeSuffix, " > ").concat(componentCls), (_$concat$concat$conca2 = {
    color: itemColor,
    background: itemBg
  }, _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-root:focus-visible"), Object.assign({}, accessibilityFocus(token))), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item-group-title"), {
    color: groupTitleColor
  }), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-submenu-selected"), _defineProperty({}, "> ".concat(componentCls, "-submenu-title"), {
    color: itemSelectedColor
  })), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item-disabled, ").concat(componentCls, "-submenu-disabled"), {
    color: "".concat(itemDisabledColor, " !important")
  }), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item:not(").concat(componentCls, "-item-selected):not(").concat(componentCls, "-submenu-selected)"), _defineProperty({}, "&:hover, > ".concat(componentCls, "-submenu-title:hover"), {
    color: itemHoverColor
  })), _defineProperty(_$concat$concat$conca2, "&:not(".concat(componentCls, "-horizontal)"), (_not$concat = {}, _defineProperty(_not$concat, "".concat(componentCls, "-item:not(").concat(componentCls, "-item-selected)"), {
    '&:hover': {
      backgroundColor: itemHoverBg
    },
    '&:active': {
      backgroundColor: itemActiveBg
    }
  }), _defineProperty(_not$concat, "".concat(componentCls, "-submenu-title"), {
    '&:hover': {
      backgroundColor: itemHoverBg
    },
    '&:active': {
      backgroundColor: itemActiveBg
    }
  }), _not$concat)), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item-danger"), (_$concat3 = {
    color: dangerItemColor
  }, _defineProperty(_$concat3, "&".concat(componentCls, "-item:hover"), _defineProperty({}, "&:not(".concat(componentCls, "-item-selected):not(").concat(componentCls, "-submenu-selected)"), {
    color: dangerItemHoverColor
  })), _defineProperty(_$concat3, "&".concat(componentCls, "-item:active"), {
    background: dangerItemActiveBg
  }), _$concat3)), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item a"), {
    '&, &:hover': {
      color: 'inherit'
    }
  }), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item-selected"), (_$concat4 = {
    color: itemSelectedColor
  }, _defineProperty(_$concat4, "&".concat(componentCls, "-item-danger"), {
    color: dangerItemSelectedColor
  }), _defineProperty(_$concat4, "a, a:hover", {
    color: 'inherit'
  }), _$concat4)), _defineProperty(_$concat$concat$conca2, "& ".concat(componentCls, "-item-selected"), _defineProperty({
    backgroundColor: itemSelectedBg
  }, "&".concat(componentCls, "-item-danger"), {
    backgroundColor: dangerItemSelectedBg
  })), _defineProperty(_$concat$concat$conca2, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), _defineProperty({}, "&:not(".concat(componentCls, "-item-disabled):focus-visible"), Object.assign({}, accessibilityFocus(token)))), _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-submenu > ").concat(componentCls), {
    backgroundColor: menuSubMenuBg
  }), _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-popup > ").concat(componentCls), {
    backgroundColor: popupBg
  }), _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-horizontal"), Object.assign(Object.assign({}, themeSuffix === 'dark' ? {
    borderBottom: 0
  } : {}), _defineProperty({}, "> ".concat(componentCls, "-item, > ").concat(componentCls, "-submenu"), (_$concat$concat2 = {
    top: activeBarBorderWidth,
    marginTop: -activeBarBorderWidth,
    marginBottom: 0,
    borderRadius: horizontalItemBorderRadius,
    '&::after': {
      position: 'absolute',
      insetInline: itemPaddingInline,
      bottom: 0,
      borderBottom: "".concat(activeBarHeight, "px solid transparent"),
      transition: "border-color ".concat(motionDurationSlow, " ").concat(motionEaseInOut),
      content: '""'
    }
  }, _defineProperty(_$concat$concat2, "&:hover, &-active, &-open", {
    background: horizontalItemHoverBg,
    '&::after': {
      borderBottomWidth: activeBarHeight,
      borderBottomColor: horizontalItemSelectedColor
    }
  }), _defineProperty(_$concat$concat2, "&-selected", {
    color: horizontalItemSelectedColor,
    backgroundColor: horizontalItemSelectedBg,
    '&:hover': {
      backgroundColor: horizontalItemSelectedBg
    },
    '&::after': {
      borderBottomWidth: activeBarHeight,
      borderBottomColor: horizontalItemSelectedColor
    }
  }), _$concat$concat2)))), _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-root"), _defineProperty({}, "&".concat(componentCls, "-inline, &").concat(componentCls, "-vertical"), {
    borderInlineEnd: "".concat(activeBarBorderWidth, "px ").concat(lineType, " ").concat(colorSplit)
  })), _defineProperty(_$concat$concat$conca2, "&".concat(componentCls, "-inline"), (_$concat8 = {}, _defineProperty(_$concat8, "".concat(componentCls, "-sub").concat(componentCls, "-inline"), {
    background: subMenuItemBg
  }), _defineProperty(_$concat8, "".concat(componentCls, "-item, ").concat(componentCls, "-submenu-title"), activeBarBorderWidth && activeBarWidth ? {
    width: "calc(100% + ".concat(activeBarBorderWidth, "px)")
  } : {}), _defineProperty(_$concat8, "".concat(componentCls, "-item"), _defineProperty({
    position: 'relative',
    '&::after': {
      position: 'absolute',
      insetBlock: 0,
      insetInlineEnd: 0,
      borderInlineEnd: "".concat(activeBarWidth, "px solid ").concat(itemSelectedColor),
      transform: 'scaleY(0.0001)',
      opacity: 0,
      transition: ["transform ".concat(motionDurationMid, " ").concat(motionEaseOut), "opacity ".concat(motionDurationMid, " ").concat(motionEaseOut)].join(','),
      content: '""'
    }
  }, "&".concat(componentCls, "-item-danger"), {
    '&::after': {
      borderInlineEndColor: dangerItemSelectedColor
    }
  })), _defineProperty(_$concat8, "".concat(componentCls, "-selected, ").concat(componentCls, "-item-selected"), {
    '&::after': {
      transform: 'scaleY(1)',
      opacity: 1,
      transition: ["transform ".concat(motionDurationMid, " ").concat(motionEaseInOut), "opacity ".concat(motionDurationMid, " ").concat(motionEaseInOut)].join(',')
    }
  }), _$concat8)), _$concat$concat$conca2));
};

export default getThemeStyle;